import * as React from 'react';
import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';
import clsx from 'clsx';

const styles = createStyles(({ palette, typography }) => ({
  root: {
    border: '2px solid currentColor',
    color: palette.textSecondary,
    borderRadius: '50%',
    width: 32,
    height: 32,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...typography.body,
    fontWeight: typography.weights.bold,
  },
}));

export type AvatarProps = React.HTMLAttributes<HTMLDivElement>;

const Avatar: React.FC<AvatarProps & WithStyles<typeof styles>> = (props) => {
  const { children, classes, className, ...rest } = props;
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      {children}
    </div>
  );
};

const StyledAvatar = withStyles(styles)(Avatar);
export { StyledAvatar as Avatar };
